module.exports = __webpack_public_path__ + "img/about3.e395daa.jpg";